module.exports = __webpack_public_path__ + "img/w_taiwhenua.d3c5fccf.png";